import React from 'react';
import ImageGallery from 'react-image-gallery';
import 'react-image-gallery/styles/css/image-gallery.css';
import 'bootstrap/dist/css/bootstrap.css';

export const CommonBusinessHeader = ({
  dataList = [],
  getNameKey = 'businessName',
  defaultBanner = 'assets/images/service-provider/air-conditioning/banner-a.jpg',
  defaultLogo = 'assets/images/service-provider/air-conditioning/banner-a.jpg',
}) => {
  // Banner header removed from owner dashboard pages (per request).
  // Early-return null removes it across all owner pages at once; the original
  // markup is kept below for easy restore if ever needed.
  return null;
  // eslint-disable-next-line no-unreachable
  return (
    <div>
      {dataList?.length > 0 ? (
        dataList.map((item, index) => {
          const bannerImages = item?.businessMedia
            ?.filter(
              (media) =>
                media?.mediaType === 'BANNER' ||
                media?.mediaType === 'MAIN_BANNER' ||
                media?.mediaType === 'IMAGES'
            )
            ?.map((media) => ({
              original: media?.media?.path,
              originalHeight: '300',
              originalWidth: '400',
              sizes: '200',
            }));

          const imagesToShow =
            bannerImages?.length > 0
              ? bannerImages
              : [
                  {
                    original: defaultBanner,
                    originalHeight: '300',
                    originalWidth: '400',
                    sizes: '200',
                  },
                ];

          const logoMedia = item?.businessMedia?.find(
            (media) => media?.mediaType === 'LOGO'
          );

          return (
            <div className="sp-banner" key={index}>
              <ImageGallery
                items={imagesToShow}
                showThumbnails={false}
                className="img-fluid sp-banner-img"
              />

              <div className="sp-logo">
                <div className="line-a">
                  <img
                    src={logoMedia?.media?.path || defaultLogo}
                    alt="logo"
                    className="img-fluid"
                  />
                </div>
                <div className="line-b">{item?.[getNameKey]}</div>
              </div>
            </div>
          );
        })
      ) : (
        <div className="sp-banner">
          <img src={defaultBanner} alt="" className="img-fluid sp-banner-img" />
          <div className="sp-logo">
            <div className="line-a">
              <img src={defaultLogo} alt="" className="img-fluid" />
            </div>
            <div className="line-b"></div>
          </div>
        </div>
      )}
    </div>
  );
};
